import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const RootPage = lazy(() => import("@/pages/root/page"));
const LoginPage = lazy(() => import("@/pages/login/page"));
const RegisterPage = lazy(() => import("@/pages/register/page"));
const PricingPage = lazy(() => import("@/pages/pricing/page"));
const PurchasePage = lazy(() => import("@/pages/purchase/page"));
const DashboardPage = lazy(() => import("@/pages/dashboard/page"));
const ResellerPage = lazy(() => import("@/pages/reseller/page"));
const ResellerProfilePage = lazy(() => import("@/pages/reseller-profile/page"));
const ResellerTermsPage = lazy(() => import("@/pages/reseller-terms/page"));
const TrackOrderPage = lazy(() => import("@/pages/track-order/page"));
const PaymentSuccessPage = lazy(() => import("@/pages/payment-success/page"));
const ProfilePage = lazy(() => import("@/pages/profile/page"));
const TermsOfServicePage = lazy(() => import("@/pages/terms-of-service/page"));
const PrivacyPolicyPage = lazy(() => import("@/pages/privacy-policy/page"));
const MonthlyChallengePage = lazy(() => import("@/pages/monthly-challenge/page"));
const FreeDataPage = lazy(() => import("@/pages/free-data/page"));
const NetworkDataPage = lazy(() => import("@/pages/network-data/page"));
const ApiDocsPage = lazy(() => import("@/pages/api-docs/page"));
const MapPage = lazy(() => import("@/pages/map/page"));
const AdminPage = lazy(() => import("@/pages/admin/page"));
const AdminOrdersPage = lazy(() => import("@/pages/admin/orders/page"));
const AdminPhoneNamesPage = lazy(() => import("@/pages/admin/phone-names/page"));
const ResellerLeaderboardPage = lazy(() => import("@/pages/reseller-leaderboard/page"));
const WalletPage = lazy(() => import("@/pages/wallet/page"));
const ForgotPasswordPage = lazy(() => import("@/pages/forgot-password/page"));
const BuyPage = lazy(() => import("@/pages/buy/page"));
const NotFoundPage = lazy(() => import("@/pages/NotFound"));
const CustomerDiscountsPage = lazy(() => import("@/pages/admin/customer-discounts/page"));
const AdminResellersPage = lazy(() => import("@/pages/admin/resellers/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/purchase",
    element: <PurchasePage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/reseller",
    element: <ResellerPage />,
  },
  {
    path: "/reseller/:referralCode",
    element: <ResellerProfilePage />,
  },
  {
    path: "/reseller-terms",
    element: <ResellerTermsPage />,
  },
  {
    path: "/reseller-leaderboard",
    element: <ResellerLeaderboardPage />,
  },
  {
    path: "/track-order",
    element: <TrackOrderPage />,
  },
  {
    path: "/buy",
    element: <BuyPage />,
  },
  {
    path: "/payment-success",
    element: <PaymentSuccessPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/monthly-challenge",
    element: <MonthlyChallengePage />,
  },
  {
    path: "/free-data",
    element: <FreeDataPage />,
  },
  {
    path: "/mtn-data-bundles",
    element: <NetworkDataPage />,
  },
  {
    path: "/telecel-data-bundles",
    element: <NetworkDataPage />,
  },
  {
    path: "/airteltigo-data-bundles",
    element: <NetworkDataPage />,
  },
  {
    path: "/api-docs",
    element: <ApiDocsPage />,
  },
  {
    path: "/map",
    element: <MapPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/admin/orders",
    element: <AdminOrdersPage />,
  },
  {
    path: "/admin/phone-names",
    element: <AdminPhoneNamesPage />,
  },
  {
    path: "/admin/customer-discounts",
    element: <CustomerDiscountsPage />,
  },
  {
    path: "/admin/resellers",
    element: <AdminResellersPage />,
  },
  {
    path: "/wallet",
    element: <WalletPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;